import { Menu } from 'antd';
import { ItemType } from 'antd/es/menu/interface';
import { MenuProps } from 'antd/lib/menu';
import React, { useMemo, useRef, useState } from 'react';
import { WorkspaceView } from '../../types/WorkspaceView';

interface HeaderMenuProps {
  headerItems?: ItemType[];
  selectedView?: WorkspaceView;
  onClickHeaderMenu: MenuProps['onClick'];
}

export const SpaceViewsHeader: React.FC<HeaderMenuProps> = ({ headerItems, selectedView, onClickHeaderMenu }) => {
  const menuRef = useRef<HTMLDivElement | null>(null);
  const [isHovering, setIsHovering] = useState(false);

  // Filter items to show/hide "new_view" based on hover state
  const visibleItems = useMemo(() => {
    if (!headerItems) return [];
    if (isHovering) return headerItems;
    return headerItems.filter((item) => item?.key !== 'new_view');
  }, [headerItems, isHovering]);

  return (
    <div
      className="flex items-center grow"
      ref={menuRef}
      onMouseEnter={() => setIsHovering(true)}
      onMouseLeave={() => setIsHovering(false)}
    >
      <Menu
        onClick={onClickHeaderMenu}
        selectedKeys={[selectedView?.id?.toString() || '']}
        mode="horizontal"
        className="h-9 grow !border-b-0 [&_.ant-menu-item]:text-neutral-900 [&_.ant-menu-item-active]:!text-neutral-900 [&_.ant-menu-item-selected]:!text-brand-grey-dark [&_.ant-menu-item]:!px-0 [&_.ant-menu-item:after]:hidden [&_.ant-menu-item-selected:after]:!block [&_.ant-menu-item-selected:after]:![inset-inline-end:0] [&_.ant-menu-item-selected:after]:![inset-inline-start:0] [&_.ant-menu-submenu-title]:![line-height:36px] [&_.ant-menu-submenu-title]:![height:36px]"
        items={visibleItems}
        triggerSubMenuAction="click"
      />
    </div>
  );
};
